module.exports = __webpack_public_path__ + "img/alarm-system-2.789d1e5b.png";